/**
 * Singular form of a table's plural label, for dialog titles and toasts
 * ("New Food Allergy", "Menu Category saved").
 *
 * Replaces `label.replace(/s$/, '')`, which produced "Food Allergie",
 * "Printer Categorie" and "Feeding Statu".
 */
export function singularLabel(label: string): string {
  if (/ies$/i.test(label)) return label.replace(/ies$/i, 'y');
  if (/(ss|us)$/i.test(label)) return label;
  return label.replace(/s$/i, '');
}
